<template>
  <section class="analytics">
    <h1>{{ $t('ANALYTICS') }}</h1>
  </section>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

.analytics {
  padding: $gs * 2;
}
</style>

<script>
// @flow
export default {
  name: 'analytics'
}
</script>
